import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { ActivityCRUDInterface } from '../../../../shared/component/filter/filter.class';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  IChangeStationActivity,
  IChangeStationActivityRow,
} from '../../../../view/settings/api-automation-settings/change-station-activity/change-station-activity.model';
import { TaskFilterCRUDInterface } from '../../../../shared/component/filter/filter.class';

export enum ActionTypes {
  CHANGE_STATION_ACTIVITYS_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] CHANGE_STATION_ACTIVITYS DATA LOADING',
  CHANGE_STATION_ACTIVITYS_DATA_LOADED = '[CHANGE_STATION_ACTIVITYS] CHANGE_STATION_ACTIVITYS DATA LOADED',
  GET_CHANGE_STATION_ACTIVITY = '[CHANGE_STATION_ACTIVITYS] GET_CHANGE_STATION_ACTIVITY LOADING',
  GET_CHANGE_STATION_ACTIVITY_COMPLETED = '[CHANGE_STATION_ACTIVITYS] GET_CHANGE_STATION_ACTIVITY COMPLETED',
  ADD_CHANGE_STATION_ACTIVITY = '[CHANGE_STATION_ACTIVITYS] ADD_CHANGE_STATION_ACTIVITY',
  ADD_CHANGE_STATION_ACTIVITY_COMPLETED = '[CHANGE_STATION_ACTIVITYS] ADD_CHANGE_STATION_ACTIVITY COMPLETED',
  EDIT_CHANGE_STATION_ACTIVITY = '[CHANGE_STATION_ACTIVITYS] EDIT_CHANGE_STATION_ACTIVITY',
  EDIT_CHANGE_STATION_ACTIVITY_COMPLETED = '[CHANGE_STATION_ACTIVITYS] EDIT_CHANGE_STATION_ACTIVITY COMPLETED',
  DELETE_CHANGE_STATION_ACTIVITYS = '[CHANGE_STATION_ACTIVITYS] DELETE_CHANGE_STATION_ACTIVITYS',
  DELETE_CHANGE_STATION_ACTIVITYS_COMPLETED = '[CHANGE_STATION_ACTIVITYS] DELETE_CHANGE_STATION_ACTIVITYS COMPLETED',
  ACTIVITIES_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] ACTIVITIES DATA LOADING',
  ACTIVITIES_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] ACTIVITIES DATA COMPLETED',
  TASKS_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] TASKS DATA LOADING',
  TASKS_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] TASKS DATA COMPLETED',
  EXTENDED_TASKS_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] EXTENDED_TASKS DATA LOADING',
  EXTENDED_TASKS_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] EXTENDED_TASKS DATA COMPLETED',
  LINE_DESTINATIONS_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] LINE_DESTINATIONS DATA LOADING',
  LINE_DESTINATIONS_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] LINE_DESTINATIONS DATA COMPLETED',
  CLEANER_RULES_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] CLEANER_RULES DATA LOADING',
  CLEANER_RULES_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] CLEANER_RULES DATA COMPLETED',
  TASK_LOOKUP_DATA_LOADING = '[CHANGE_STATION_ACTIVITYS] TASK_LOOKUP DATA LOADING',
  TASK_LOOKUP_DATA_COMPLETED = '[CHANGE_STATION_ACTIVITYS] TASK_LOOKUP DATA COMPLETED',
  FETCH_ERROR = '[CHANGE_STATION_ACTIVITYS] FETCH ERROR',
}

export class ChangeStationActivitiesLoading implements Action {
  readonly type = ActionTypes.CHANGE_STATION_ACTIVITYS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class ChangeStationActivitiesLoaded implements Action {
  readonly type = ActionTypes.CHANGE_STATION_ACTIVITYS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IChangeStationActivity>) {}
}

export class GetChangeStationActivity implements Action {
  readonly type = ActionTypes.GET_CHANGE_STATION_ACTIVITY;

  constructor(public recordId: number) {}
}

export class GetChangeStationActivityCompleted implements Action {
  readonly type = ActionTypes.GET_CHANGE_STATION_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeStationActivity>) {}
}
export class AddChangeStationActivity implements Action {
  readonly type = ActionTypes.ADD_CHANGE_STATION_ACTIVITY;

  constructor(
    public record: IChangeStationActivityRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddChangeStationActivityCompleted implements Action {
  readonly type = ActionTypes.ADD_CHANGE_STATION_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeStationActivity>) {}
}
export class EditChangeStationActivity implements Action {
  readonly type = ActionTypes.EDIT_CHANGE_STATION_ACTIVITY;

  constructor(
    public recordId: number,
    public record: IChangeStationActivityRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditChangeStationActivityCompleted implements Action {
  readonly type = ActionTypes.EDIT_CHANGE_STATION_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeStationActivity>) {}
}
export class DeleteChangeStationActivities implements Action {
  readonly type = ActionTypes.DELETE_CHANGE_STATION_ACTIVITYS;

  constructor(public payload: number[]) {}
}

export class DeleteChangeStationActivitiesCompleted implements Action {
  readonly type = ActionTypes.DELETE_CHANGE_STATION_ACTIVITYS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ActivitiesDataLoading implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_LOADING;

  constructor() {}
}

export class ActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: ActivityCRUDInterface[]) {}
}
export class TasksDataLoading implements Action {
  readonly type = ActionTypes.TASKS_DATA_LOADING;

  constructor(public activityId: number) {}
}

export class TasksDataCompleted implements Action {
  readonly type = ActionTypes.TASKS_DATA_COMPLETED;

  constructor(public payload: TaskFilterCRUDInterface[]) {}
}
export class ExtendedTasksDataLoading implements Action {
  readonly type = ActionTypes.EXTENDED_TASKS_DATA_LOADING;

  constructor(public activityId: number) {}
}

export class ExtendedTasksDataCompleted implements Action {
  readonly type = ActionTypes.EXTENDED_TASKS_DATA_COMPLETED;

  constructor(public payload: TaskFilterCRUDInterface[]) {}
}
export class LineDestinationsDataLoading implements Action {
  readonly type = ActionTypes.LINE_DESTINATIONS_DATA_LOADING;

  constructor() {}
}

export class LineDestinationsDataCompleted implements Action {
  readonly type = ActionTypes.LINE_DESTINATIONS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class CleanerRulesDataLoading implements Action {
  readonly type = ActionTypes.CLEANER_RULES_DATA_LOADING;

  constructor() {}
}

export class CleanerRulesDataCompleted implements Action {
  readonly type = ActionTypes.CLEANER_RULES_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class TaskLookupDataLoading implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_LOADING;

  constructor(public taskIds: number[]) {}
}

export class TaskLookupDataCompleted implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type ChangeStationActivityActions =
  | ChangeStationActivitiesLoading
  | ChangeStationActivitiesLoaded
  | GetChangeStationActivity
  | GetChangeStationActivityCompleted
  | AddChangeStationActivity
  | AddChangeStationActivityCompleted
  | EditChangeStationActivity
  | EditChangeStationActivityCompleted
  | DeleteChangeStationActivities
  | DeleteChangeStationActivitiesCompleted
  | ActivitiesDataLoading
  | ActivitiesDataCompleted
  | TasksDataLoading
  | TasksDataCompleted
  | ExtendedTasksDataLoading
  | ExtendedTasksDataCompleted
  | LineDestinationsDataLoading
  | LineDestinationsDataCompleted
  | CleanerRulesDataLoading
  | CleanerRulesDataCompleted
  | TaskLookupDataLoading
  | TaskLookupDataCompleted
  | FetchError;
